module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8.3 17.39"}},[_c('defs'),_c('title',[_v("arrow-dx")]),_c('g',{attrs:{"id":"Livello_2","data-name":"Livello 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M.5.5l7.14 7.72L.5 16.89","id":"Layer_2","data-name":"Layer 2"}})])])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-dx.svg
// module id = 411
// module chunks = 1